import { useState, } from 'react';
import { usePrevious, } from 'react-use';
import _ from 'lodash';

export function useIsEqualPrev(propValue) {
    const [value, ] = useState(propValue);
    const prevValue = usePrevious(value);

    return _.isEqual(propValue, prevValue);
};